<template>
  <portal-layout>
    <div class="result-page" v-loading="loading">
      <template v-if="!loading && exam">
        <!-- 成绩概览 -->
        <div class="score-card">
          <div class="score-main">
            <p class="score-label">本次得分</p>
            <p class="score-value">{{ record.totalScore }}<span class="score-unit">分</span></p>
            <p class="exam-name">{{ exam.examName }}</p>
          </div>
          <div class="score-stats">
            <div class="stat-item">
              <span class="stat-value">{{ problems.length }}</span>
              <span class="stat-label">总题数</span>
            </div>
            <div class="stat-item">
              <span class="stat-value correct-count">{{ correctCount }}</span>
              <span class="stat-label">答对题数</span>
            </div>
            <div class="stat-item">
              <span class="stat-value correct-rate">{{ correctRate }}%</span>
              <span class="stat-label">正确率</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ record.submitTime }}</span>
              <span class="stat-label">提交时间</span>
            </div>
          </div>
          <div class="score-actions">
            <el-button type="primary" @click="goBack">返回考试列表</el-button>
            <el-button type="primary" plain @click="viewDetail">查看答题详情</el-button>
          </div>
        </div>

        <!-- 逐题结果 -->
        <div class="detail-section">
          <h3 class="section-title">答题详情</h3>
          <div v-for="(problem, index) in problems" :key="problem.examProblemId" class="problem-result">
            <div class="problem-header">
              <span class="problem-index" :class="problem.isCorrect === '1' ? 'bg-correct' : 'bg-wrong'">
                {{ index + 1 }}
              </span>
              <el-tag size="mini" :type="tagType(problem.type)">{{ formatType(problem.type) }}</el-tag>
              <el-tag size="mini" :type="problem.isCorrect === '1' ? 'success' : 'danger'" class="result-tag">
                {{ problem.isCorrect === '1' ? '正确 +' + problem.score : '错误 +0' }}
              </el-tag>
              <span class="problem-score">满分 {{ problem.score }} 分</span>
            </div>
            <div class="problem-content">{{ problem.content }}</div>
            <div class="option-list">
              <div v-for="option in problem.options" :key="option.key" class="option-item"
                   :class="optionClass(problem, option)">
                <span class="option-label">{{ option.key }}.</span>
                <span class="option-content">{{ option.content }}</span>
              </div>
            </div>
            <div class="answer-analysis">
              <span class="analysis-item">你的答案：<strong>{{ problem.userAnswer || '未作答' }}</strong></span>
              <span class="analysis-item">正确答案：<strong class="correct">{{ problem.correctAnswer }}</strong></span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';
export default {
  name: 'PortalCustomizeExamResult',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      exam: null,
      record: {},
      problems: []
    }
  },
  computed: {
    correctCount() {
      return this.problems.filter((item) => item.isCorrect === '1').length;
    },
    correctRate() {
      if (this.problems.length === 0) return 0;
      return Math.round((this.correctCount / this.problems.length) * 100);
    }
  },
  created() {
    let recordId = this.$route.query.recordId;
    if (!recordId) {
      this.$message.error('缺少考试记录参数');
      this.$router.push('/portal/customize/exam').catch(() => {});
      return;
    }
    this.queryDetail(recordId);
  },
  methods: {
    queryDetail(recordId) {
      this.loading = true;
      api.hoj_customize_exam_detail({ recordId: recordId }).then((r) => {
        if (r.data.code === "200") {
          let data = r.data.data;
          this.exam = data.exam;
          this.record = data.record;
          this.problems = data.problems || [];
        } else {
          this.$message.error(r.data.msg || '查询成绩失败');
        }
      }).catch(() => {
        // 未登录(401)已由 common/api.js 统一跳转门户登录页，这里不重复跳转
      }).finally(() => {
        this.loading = false;
      });
    },
    formatType(type) {
      const map = { single: '单选题', multiple: '多选题', truefalse: '判断题' };
      return map[type] || type;
    },
    tagType(type) {
      const map = { single: '', multiple: 'success', truefalse: 'warning' };
      return map[type] || '';
    },
    optionClass(problem, option) {
      let isCorrectOption = (problem.correctAnswer || '').split(',').indexOf(option.key) > -1;
      let isUserOption = (problem.userAnswer || '').split(',').indexOf(option.key) > -1;
      if (isCorrectOption) {
        return { 'option-correct': true };
      }
      if (isUserOption && !isCorrectOption) {
        return { 'option-wrong': true };
      }
      return {};
    },
    goBack() {
      this.$router.push('/portal/customize/exam').catch(() => {});
    },
    viewDetail() {
      this.$router.push('/portal/customize/exam/answer?recordId=' + this.record.recordId).catch(() => {});
    }
  }
};
</script>
<style scoped>
.result-page {
  min-height: 300px;
}
.score-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 35px;
  margin-bottom: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  text-align: center;
}
.score-main {
  padding-bottom: 25px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 25px;
}
.score-label {
  font-size: 14px;
  color: #909399;
  margin: 0 0 10px 0;
}
.score-value {
  font-size: 56px;
  color: #F56C6C;
  font-weight: bold;
  margin: 0;
  line-height: 1.1;
}
.score-unit {
  font-size: 20px;
  margin-left: 5px;
}
.exam-name {
  font-size: 16px;
  color: #303133;
  margin: 10px 0 0 0;
}
.score-stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 25px;
}
.stat-item {
  display: flex;
  flex-direction: column;
}
.stat-value {
  font-size: 22px;
  color: #303133;
  font-weight: bold;
  margin-bottom: 6px;
}
.stat-value.correct-count {
  color: #67C23A;
}
.stat-value.correct-rate {
  color: #409EFF;
}
.stat-label {
  font-size: 13px;
  color: #909399;
}
.score-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}
.detail-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.section-title {
  font-size: 18px;
  color: #303133;
  margin: 0 0 20px 0;
}
.problem-result {
  padding: 20px 0;
  border-bottom: 1px solid #ebeef5;
}
.problem-result:last-child {
  border-bottom: none;
}
.problem-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.problem-index {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  margin-right: 12px;
}
.bg-correct {
  background-color: #67C23A;
}
.bg-wrong {
  background-color: #F56C6C;
}
.result-tag {
  margin-left: 12px;
}
.problem-score {
  margin-left: auto;
  font-size: 13px;
  color: #909399;
}
.problem-content {
  font-size: 15px;
  color: #303133;
  line-height: 1.7;
  margin-bottom: 15px;
  white-space: pre-wrap;
}
.option-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.option-item {
  padding: 8px 15px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  font-size: 14px;
}
.option-item.option-correct {
  background-color: #f0f9eb;
  border-color: #67C23A;
}
.option-item.option-wrong {
  background-color: #fef0f0;
  border-color: #F56C6C;
}
.option-label {
  font-weight: bold;
  margin-right: 8px;
}
.answer-analysis {
  margin-top: 15px;
  font-size: 14px;
  color: #606266;
}
.analysis-item {
  margin-right: 30px;
}
.analysis-item .correct {
  color: #67C23A;
}
</style>
